export default __webpack_public_path__ + "static/media/LT.77023a82.svg";